export const DateFormat = {
  MMDDYYYY: 'MM/DD/YYYY',
  DDMMYYYY: 'DD/MM/YYYY',
};

export const DateFormatValues = [
  { value: DateFormat.MMDDYYYY, label: 'MM/DD/YYYY (MDY)' },
  { value: DateFormat.DDMMYYYY, label: 'DD/MM/YYYY (DMY)' },
];
